module.exports = __webpack_public_path__ + "img/alb.663dea23.svg";